const moreOfWhatYouLoveOfferFilterImpressions = (
  _state: WtrState,
  { payload: { onOffer } }: { payload: { onOffer: boolean } },
) => {
  return {
    event: 'filter',
    filter_name: 'Quick Shop Filter',
    filter_label: 'Only offers',
    filter_selection: onOffer ? 'Only offers' : 'All Products',
    filter_location: 'normal',
    filter_type: 'user-applied',
    item_list_name: 'Quick Shop',
    item_list_id: 'List_Purchase History_Quick Shop',
  };
};

export default moreOfWhatYouLoveOfferFilterImpressions;
